import React, { useEffect, useState } from 'react';
import { FaSun, FaLeaf, FaSolarPanel, FaRulerCombined } from 'react-icons/fa';
import { MdRoofing } from 'react-icons/md';
import { IoMdSettings } from 'react-icons/io';

const BuildingInsightComponent = ({ building_insights, updateindex, updatemanualPlacementMode,manualPlacementMode1 }) => {
    const [selectedPanelCountIndex, setSelectedPanelCountIndex] = useState(0);
    const [panelCapacity, setPanelCapacity] = useState(250);
    const [manualPlacementMode, setManualPlacementMode] = useState(false);

    const toggleManualPlacementMode = () => {
        setManualPlacementMode(!manualPlacementMode);
        updatemanualPlacementMode(!manualPlacementMode);
    };

    const handleSliderChange = (event) => {
        setSelectedPanelCountIndex(parseInt(event.target.value));
        updateindex(parseInt(event.target.value));
    };

    const handlePanelCapacityChange = (event) => {
        setPanelCapacity(parseFloat(event.target.value));
    };

    useEffect(() => {
        setManualPlacementMode(manualPlacementMode1);
    }, [manualPlacementMode1]);

    useEffect(() => {
        setSelectedPanelCountIndex(0);
        setPanelCapacity(250);
    }, [building_insights]);

    if (!building_insights || !building_insights.solarPotential || !building_insights.solarPotential.solarPanelConfigs) {
        return <div>Loading...</div>;
    }

    const {
        maxSunshineHoursPerYear,
        wholeRoofStats: { areaMeters2 },
        carbonOffsetFactorKgPerMwh,
        panelHeightMeters,
        panelWidthMeters
    } = building_insights.solarPotential;

    const solar_panel_configs = building_insights.solarPotential.solarPanelConfigs;

    return (
        <div>
            {/* ✅ Building Insights Box (Bottom Center) */}
            <div 
                style={{
                    position: 'absolute',
                    bottom: '10%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '20vw',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                    borderRadius: '12px',
                    padding: '15px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    fontFamily: "'Poppins', sans-serif",
                    zIndex: 100,
                    textAlign: 'center'
                }}
            >
                <h2 style={{ 
                    fontSize: '18px', 
                    fontWeight: '600', 
                    marginBottom: '10px', 
                    color: '#2E2E2E',
                    letterSpacing: '0.5px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <IoMdSettings size={20} style={{ color: '#FF9800' }} />
                    Building Insights
                </h2>
                <ul style={{ listStyle: 'none', padding: 0, fontSize: '14px', color: '#444' }}>
                    <li style={{ marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaSun color="#FBC02D" size={18} /> 
                        Annual Sunshine: <strong>{maxSunshineHoursPerYear.toFixed(2)} hrs</strong>
                    </li>
                    <li style={{ marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <MdRoofing color="#8D6E63" size={18} /> 
                        Roof Area: <strong>{areaMeters2.toFixed(2)} m²</strong>
                    </li>
                    <li style={{ marginBottom: '6px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FaLeaf color="#4CAF50" size={18} /> 
                        Carbon Saving: <strong>{carbonOffsetFactorKgPerMwh.toFixed(2)} kg/MWh</strong>
                    </li>
                </ul>
                <button 
                    onClick={toggleManualPlacementMode}
                    style={{
                        backgroundColor: manualPlacementMode ? '#F44336' : '#4CAF50',
                        color: 'white',
                        border: 'none',
                        padding: '10px 14px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        transition: '0.3s ease',
                        fontSize: '14px',
                        fontWeight: '500',
                        letterSpacing: '0.3px',
                        marginTop: '10px'
                    }}
                >
                    {manualPlacementMode ? 'Disable Manual Mode' : 'Enable Manual Mode'}
                </button>
            </div>

            {/* ✅ Solar Panel Config Box (Right Side) */}
            {!manualPlacementMode && (
    <div 
        style={{
            position: 'absolute',
            top: '50%',
            right: '20px',
            transform: 'translateY(-50%)',
            width: '22vw',
            height: 'auto',
            minHeight: '40vh',
            maxHeight: '70vh',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.12)',
            borderRadius: '15px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
            overflowY: 'auto',
            fontFamily: "'Poppins', sans-serif",
            zIndex: 10
        }}
    >
        {/* Header with Icon */}
        <h3 style={{ 
            textAlign: 'center', 
            marginBottom: '15px', 
            fontSize: '18px', 
            fontWeight: '600', 
            color: '#333', 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
        }}>
            <FaSolarPanel size={22} color="#FF9800" /> Solar Panel Configuration
        </h3>

        {/* Panel Dimensions */}
        <ul style={{ 
            listStyle: 'none', 
            padding: 0, 
            fontSize: '14px', 
            color: '#444', 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '6px'
        }}>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaRulerCombined color="#607D8B" /> Panel Height: <strong>{panelHeightMeters.toFixed(2)} m</strong>
            </li>
            <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaRulerCombined color="#607D8B" /> Panel Width: <strong>{panelWidthMeters.toFixed(2)} m</strong>
            </li>
        </ul>

        {/* Panel Count Slider */}
        <div style={{ marginTop: '15px', textAlign: 'center' }}>
            <label style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>Select Panel Count</label>
            <input
                type="range"
                min={0}
                max={solar_panel_configs.length - 1}
                value={selectedPanelCountIndex}
                onChange={handleSliderChange}
                style={{
                    width: '100%',
                    marginTop: '5px',
                    cursor: 'pointer',
                    accentColor: '#FF9800'
                }}
            />
            <p style={{ fontSize: '14px', marginTop: '5px', fontWeight: '500' }}>
                Panel Count: <strong>{solar_panel_configs[selectedPanelCountIndex]?.panelsCount}</strong>
            </p>
        </div>

        {/* Yearly Energy Output */}
        <p style={{ 
            marginTop: '10px', 
            fontSize: '14px', 
            fontWeight: '500', 
            textAlign: 'center', 
            color: '#333' 
        }}>
            Estimated Yearly Energy (DC): <strong>{(solar_panel_configs[selectedPanelCountIndex]?.yearlyEnergyDcKwh * (panelCapacity / 400)).toFixed(2)} kWh</strong>
        </p>

        {/* Panel Capacity Input */}
        <div style={{ marginTop: '15px', textAlign: 'center' }}>
            <label style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>Panel Capacity (Watts)</label>
            <input
                type="number"
                value={panelCapacity}
                onChange={handlePanelCapacityChange}
                style={{
                    width: '100%',
                    padding: '8px',
                    marginTop: '5px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    fontSize: '14px',
                    textAlign: 'center',
                    transition: '0.2s ease',
                    outline: 'none'
                }}
                onFocus={(e) => e.target.style.border = '1px solid #FF9800'}
                onBlur={(e) => e.target.style.border = '1px solid #ccc'}
            />
        </div>
    </div>
)}
        </div>
    );
};

export default BuildingInsightComponent;
